import http, { jwksApi } from "./api-communicator";
import { noop } from "@client/shared/constants";
import { responseFormatter } from "@client/utils";
import config from "@client/config";
export { default as http } from "./api-communicator";

const RC_PRODUCTION_URL = config.rcApiBaseUrl.includes("devtest")
  ? "https://platform.ringcentral.com/restapi/v1.0"
  : config.rcApiBaseUrl;

// let appData = {};

function logoutUser(token) {
  return responseFormatter(
    http.post(`logout`, null, {
      headers: {
        Authorization: token,
      },
    })
  );
}

function getUserDetails(token) {
  const options = {};
  if (token) {
    options.headers = {
      Authorization: token,
    };
  } else {
    options.setAuthHeader = true;
  }

  return responseFormatter(http.get("/user/me", options));
}
const patchUserPreference = (preference = "") => {
  return responseFormatter(
    http.patch(
      "/setuserpreferences",
      { delete_confirmation: preference },
      { setAuthHeader: true }
    )
  );
};
const getVersion = async () => {
  return responseFormatter(http.get("/version"));
};

const updateUserData = (userId, data) => {
  return responseFormatter(
    http.patch(`/user/${userId}`, data, { setAuthHeader: true })
  );
};

// const getAppData = () => {
//   return appData;
// };

// const setAppData = (key, data) => {
//   if (key) {
//     appData[key] = data;
//   } else {
//     appData = data;
//   }
// };

const getAccountInfo = async (accountUid = "~") => {
  const url = `${RC_PRODUCTION_URL}/account/${accountUid}`;
  return await responseFormatter.rc(jwksApi.get(url));
};

const getAssignedRoles = async (accountUid = "~",query = "", rateLimitReachedCallback = noop) => {
  const url = `${RC_PRODUCTION_URL}/account/${accountUid}/assigned-role?perPage=1000`;
  return new Promise(async (resolve) => {
    const roles = [];
    let pageCounter = 1;
    const { data, error, paging } = await responseFormatter.rc(
      jwksApi.get(`${url}${query}`),
      { hooks: { rateLimitReached: rateLimitReachedCallback } }
    );
    if (error) {
      resolve({ data: null, error });
    } else {
      roles.push(...data);
      if (paging.totalPages > 1) {
        while (pageCounter <= paging.totalPages) {
          pageCounter += 1;
          const { data, error } = await responseFormatter.rc(
            jwksApi.get(`${url}&page=${pageCounter}${query}`, {
              hooks: { rateLimitReached: rateLimitReachedCallback },
            })
          );
          error ? resolve({ data: null, error }) : roles.push(...data);
        }
      }
      resolve({ data: roles, error: null });
    }
  });
};

const getExtensions = async (
  accountUid = "~",
  query = "",
  rateLimitReachedCallback = noop
) => {
  const url = `${RC_PRODUCTION_URL}/account/${accountUid}/extension?perPage=1000`;
  return new Promise(async (resolve) => {
    const extensions = [];
    let pageCounter = 1;
    const { data, error, paging } = await responseFormatter.rc(
      jwksApi.get(`${url}${query}`),
      { hooks: { rateLimitReached: rateLimitReachedCallback } }
    );
    if (error) {
      resolve({ data: null, error });
    } else {
      extensions.push(...data);
      if (paging.totalPages > 1) {
        while (pageCounter <= paging.totalPages) {
          pageCounter += 1;
          const { data, error } = await responseFormatter.rc(
            jwksApi.get(`${url}&page=${pageCounter}${query}`, {
              hooks: { rateLimitReached: rateLimitReachedCallback },
            })
          );
          error ? resolve({ data: null, error }) : extensions.push(...data);
        }
      }
      resolve({ data: extensions, error: null });
    }
  });
};

const getSites = async (
  accountUid = "~",
  query = "",
  rateLimitReachedCallback = noop
) => {
  const url = `${RC_PRODUCTION_URL}/account/${accountUid}/sites?perPage=1000`;
  return new Promise(async (resolve) => {
    const sites = [];
    let pageCounter = 1;
    const { data, error, paging } = await responseFormatter.rc(
      jwksApi.get(`${url}${query}`),
      { hooks: { rateLimitReached: rateLimitReachedCallback } }
    );
    if (error) {
      resolve({ data: null, error });
    } else {
      sites.push(...data);
      if (paging.totalPages > 1) {
        while (pageCounter <= paging.totalPages) {
          pageCounter += 1;
          const { data, error } = await responseFormatter.rc(
            jwksApi.get(`${url}&page=${pageCounter}${query}`, {
              hooks: { rateLimitReached: rateLimitReachedCallback },
            })
          );
          error ? resolve({ data: null, error }) : sites.push(...data);
        }
      }
      resolve({ data: sites, error: null });
    }
  });
};

const getVoicemails = async (
  accountUid = "~",
  query = "",
  rateLimitReachedCallback = noop
) => {
  const url = `${RC_PRODUCTION_URL}/account/${accountUid}/voicemail-library?perPage=1000`;
  return new Promise(async (resolve) => {
    const voicemails = [];
    let pageCounter = 1;
    const { data, error, paging } = await responseFormatter.rc(
      jwksApi.get(`${url}${query}`),
      { hooks: { rateLimitReached: rateLimitReachedCallback } }
    );
    if (error) {
      resolve({ data: null, error });
    } else {
      voicemails.push(...data);
      if (paging.totalPages > 1) {
        while (pageCounter <= paging.totalPages) {
          pageCounter += 1;
          const { data, error } = await responseFormatter.rc(
            jwksApi.get(`${url}&page=${pageCounter}${query}`, {
              hooks: { rateLimitReached: rateLimitReachedCallback },
            })
          );
          error ? resolve({ data: null, error }) : voicemails.push(...data);
        }
      }
      resolve({ data: voicemails, error: null });
    }
  });
};

const getUserRoles = async (
  accountUid = "~",
  query = "",
  rateLimitReachedCallback = noop
) => {
  const url = `${RC_PRODUCTION_URL}/account/${accountUid}/user-role?perPage=1000`;
  return new Promise(async (resolve) => {
    const userRoles = [];
    let pageCounter = 1;
    const { data, error, paging } = await responseFormatter.rc(
      jwksApi.get(`${url}${query}`),
      { hooks: { rateLimitReached: rateLimitReachedCallback } }
    );
    if (error) {
      resolve({ data: null, error });
    } else {
      userRoles.push(...data);
      if (paging.totalPages > 1) {
        while (pageCounter <= paging.totalPages) {
          pageCounter += 1;
          const { data, error } = await responseFormatter.rc(
            jwksApi.get(`${url}&page=${pageCounter}${query}`, {
              hooks: { rateLimitReached: rateLimitReachedCallback },
            })
          );
          error ? resolve({ data: null, error }) : userRoles.push(...data);
        }
      }
      resolve({ data: userRoles, error: null });
    }
  });
};

const getPhoneNumbers = async (
  accountUid = "~",
  extensionId = "~",
  query = "",
  rateLimitReachedCallback = noop
) => {
  const url = `${RC_PRODUCTION_URL}/account/${accountUid}/extension/${extensionId}/phone-number?perPage=1000`;
  return new Promise(async (resolve) => {
    const phoneNumbers = [];
    let pageCounter = 1;
    const { data, error, paging } = await responseFormatter.rc(
      jwksApi.get(`${url}${query}`),
      { hooks: { rateLimitReached: rateLimitReachedCallback } }
    );
    if (error) {
      resolve({ data: null, error });
    } else {
      phoneNumbers.push(...data);
      if (paging.totalPages > 1) {
        while (pageCounter <= paging.totalPages) {
          pageCounter += 1;
          const { data, error } = await responseFormatter.rc(
            jwksApi.get(`${url}&page=${pageCounter}${query}`, {
              hooks: { rateLimitReached: rateLimitReachedCallback },
            })
          );
          error ? resolve({ data: null, error }) : phoneNumbers.push(...data);
        }
      }
      resolve({ data: phoneNumbers, error: null });
    }
  });
};

const getCountryList = async (rateLimitReachedCallback = noop) => {
  const url = `${RC_PRODUCTION_URL}/dictionary/country?perPage=1000`;
  return new Promise(async (resolve) => {
    const countryList = [];
    let pageCounter = 1;
    const { data, error, paging } = await responseFormatter.rc(
      jwksApi.get(url),
      { hooks: { rateLimitReached: rateLimitReachedCallback } }
    );
    if (error) {
      resolve({ data: null, error });
    } else {
      countryList.push(...data);
      if (paging.totalPages > 1) {
        while (pageCounter <= paging.totalPages) {
          pageCounter += 1;
          const { data, error } = await responseFormatter.rc(
            jwksApi.get(`${url}&page=${pageCounter}`, {
              hooks: { rateLimitReached: rateLimitReachedCallback },
            })
          );
          error ? resolve({ data: null, error }) : countryList.push(...data);
        }
      }
      resolve({ data: countryList, error: null });
    }
  });
};

const refreshAccessToken = async (token) => {
  return await responseFormatter(
    http.get("refreshtoken", { headers: { Authorization: token } })
  );
};

const getDefaultCallerId = async () => {
  return await responseFormatter(
    http.get(`/account`, {
      setAuthHeader: true,
    })
  );
};

export const AppService = {
  getVersion,
  getUserDetails,
  logoutUser,
  //   getAppData,
  //   setAppData,
  updateUserData,
  patchUserPreference,
  getExtensions,
  getAssignedRoles,
  getSites,
  getVoicemails,
  getUserRoles,
  getPhoneNumbers,
  getAccountInfo,
  getCountryList,
  refreshAccessToken,
  getDefaultCallerId,
};
